var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIonSpecificEventIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60156 2.84961C9.60156 4.09275 8.59396 5.09961 7.35204 5.09961C6.10917 5.09961 5.10156 4.09275 5.10156 2.84961C5.10156 1.60647 6.10917 0.599609 7.35204 0.599609C8.59396 0.599609 9.60156 1.60647 9.60156 2.84961Z",
    fill: "#FB8B24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60156 9.75C9.60156 10.9931 8.59396 12 7.35204 12C6.10917 12 5.10156 10.9931 5.10156 9.75C5.10156 8.50686 6.10917 7.5 7.35204 7.5C8.59396 7.5 9.60156 8.50686 9.60156 9.75Z",
    fill: "#FFC692"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60156 7.65039C9.60156 8.89353 8.59396 9.90039 7.35204 9.90039C6.10917 9.90039 5.10156 8.89353 5.10156 7.65039C5.10156 6.40725 6.10917 5.40039 7.35204 5.40039C8.59396 5.40039 9.60156 6.40725 9.60156 7.65039Z",
    fill: "#FB8B24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60156 12.1504C9.60156 13.3935 8.59396 14.4004 7.35204 14.4004C6.10917 14.4004 5.10156 13.3935 5.10156 12.1504C5.10156 10.9072 6.10917 9.90039 7.35204 9.90039C8.59396 9.90039 9.60156 10.9072 9.60156 12.1504Z",
    fill: "#FB8B24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonSpecificEventIcon);
export default __webpack_public_path__ + "static/media/ion-specific-event-icon.195fd98d176aa9b00212f27c42c0f568.svg";
export { ForwardRef as ReactComponent };